import React from 'react'

import { Contract, UserMetadata } from '../../../../common/validations'
import {
  DefectNoticeDefectClasses,
  DefectNoticeDetails,
} from '../../../../common/validations/defectNotice'
import { ResidentAppError } from '../../../../common/error'
import { useCurrentDefectNotice } from '../../../hooks/useCurrentDefectNotice/useCurrentDefectNotice'
import { useAPIGetDefectNoticeSuspense } from '../../../api/apiHooks/useAPIGetDefectNotice'
import { useAPIGetUserMetadataSuspense } from '../../../api/apiHooks/useAPIGetUserMetadata'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'
import { useAPIGetUserProfileSuspense } from 'api/apiHooks/useAPIGetUserProfile'
import { useAPIGetContractSuspense } from 'api/apiHooks/useAPIGetContract'
import { useAPIGetDefectClassesSuspense } from 'api/apiHooks/useAPIGetDefectClasses'

interface Data {
  contract: Contract
  defectClasses: DefectNoticeDefectClasses
  defectNotice: DefectNoticeDetails
  userMetadata: UserMetadata
}

export const EditDefectNoticeDataLoader = ({
  children,
}: {
  children: (data: Data) => React.ReactNode
}) => {
  const { currentContractId } = useCurrentContract()
  const { data: contract } = useAPIGetContractSuspense(currentContractId)
  const { data: defectClasses } = useAPIGetDefectClassesSuspense()
  const { data: user } = useAPIGetUserProfileSuspense()

  const { currentDefectNoticeUuid } = useCurrentDefectNotice()
  const { data: defectNotice } = useAPIGetDefectNoticeSuspense(
    currentContractId,
    currentDefectNoticeUuid
  )

  const { data: userMetadata } = useAPIGetUserMetadataSuspense()

  // Make sure the user has a phone number
  if (!user.phoneNumber) {
    throw ResidentAppError.ClientError('DEFECT_NOTICE_MISSING_PHONE_NUMBER')
  }

  if (!defectNotice) {
    throw ResidentAppError.ClientError('NOT_FOUND')
  }

  return children({
    contract,
    defectClasses,
    defectNotice,
    userMetadata,
  })
}
